/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';
import PropTypes from 'prop-types';

const title = _x('Cast Iron Pan', 'sticker name', 'web-stories');

const CastIron = ({ style }) => (
  <svg
    style={style}
    viewBox="0 0 78 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title}</title>
    <path
      d="M17.0002 50.5C14.0002 37.5 23.5002 33.5 26.5002 33C34.5005 33 32.5 43 38 43C43.5 43 46.8483 44.5174 46.5 48C46 53 40.8872 52.1048 38.5 53C34.5 54.5 35 58.5 31.5 60.5C29.9348 61.3944 20.0002 63.5 17.0002 50.5Z"
      fill="#FFFFA8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 44.9997C9 57.1499 18.8497 66.9997 31 66.9997C43.1503 66.9997 53 57.1499 53 44.9997C53 32.8494 43.1503 22.9997 31 22.9997C18.8497 22.9997 9 32.8494 9 44.9997ZM31 19.9997C17.1929 19.9997 6 31.1926 6 44.9997C6 58.8068 17.1929 69.9997 31 69.9997C44.8071 69.9997 56 58.8068 56 44.9997C56 31.1926 44.8071 19.9997 31 19.9997Z"
      fill="#005CD6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 44.9997C3 60.4637 15.536 72.9997 31 72.9997C46.464 72.9997 59 60.4637 59 44.9997C59 29.5357 46.464 16.9997 31 16.9997C15.536 16.9997 3 29.5357 3 44.9997ZM31 13.9997C13.8792 13.9997 0 27.8789 0 44.9997C0 62.1205 13.8792 75.9997 31 75.9997C48.1208 75.9997 62 62.1205 62 44.9997C62 27.8789 48.1208 13.9997 31 13.9997Z"
      fill="#005CD6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.9651 2.75387C68.6578 0.0612121 73.0235 0.0612078 75.7161 2.75387C78.4088 5.44653 78.4088 9.81219 75.7161 12.5049L57.6591 30.5619L55.5378 28.4406L73.5948 10.3835C75.1159 8.86244 75.1159 6.39628 73.5948 4.87519C72.0737 3.3541 69.6075 3.3541 68.0864 4.87519L50.0294 22.9322L47.9081 20.8109L65.9651 2.75387Z"
      fill="#005CD6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.3759 31.4997H26.5C28.8564 31.4997 30.5982 32.2529 31.9117 33.4561C33.1669 34.6059 33.9413 36.0906 34.5424 37.3561C34.6722 37.6294 34.7928 37.889 34.9074 38.1356C35.368 39.1268 35.7317 39.9094 36.2029 40.5309C36.7015 41.1885 37.2008 41.4997 37.9998 41.4997C40.8341 41.4997 43.3519 41.8816 45.1658 42.8794C46.0969 43.3916 46.8871 44.0911 47.4034 45.0211C47.9238 45.9585 48.1051 47.0208 47.9923 48.1489C47.8401 49.6712 47.3173 50.8751 46.4746 51.7841C45.6489 52.6749 44.622 53.1679 43.6556 53.4705C42.7212 53.763 41.743 53.9057 40.9491 54.0215L40.9032 54.0282C40.0273 54.156 39.4401 54.2491 39.0264 54.4042C37.5519 54.9571 36.8995 55.9177 36.1181 57.3003C36.058 57.4066 35.9968 57.5164 35.934 57.629C35.1986 58.9489 34.2462 60.6579 32.244 61.802C31.6049 62.1672 30.4626 62.5032 29.1452 62.6352C27.7839 62.7716 26.088 62.7065 24.3267 62.1374C20.6926 60.9633 17.1374 57.7658 15.5384 50.837C13.9395 43.9082 15.6519 39.1514 18.376 36.0689C21.0227 33.0739 24.4852 31.8148 26.2534 31.5201L26.3759 31.4997ZM26.6274 34.5007C25.3423 34.7475 22.662 35.7494 20.624 38.0555C18.5981 40.348 17.0605 44.0912 18.4616 50.1624C19.8626 56.2335 22.7746 58.4833 25.2491 59.2827C26.5421 59.7005 27.8108 59.7538 28.8462 59.6501C29.9255 59.542 30.612 59.2793 30.7555 59.1973C32.01 58.4805 32.5823 57.4645 33.3681 56.0693C33.4134 55.9889 33.4595 55.9071 33.5064 55.8241C34.35 54.3317 35.4476 52.5422 37.9731 51.5952C38.7231 51.3139 39.6276 51.1822 40.3805 51.0726C40.4106 51.0683 40.4404 51.0639 40.4699 51.0596C41.3137 50.9365 42.0727 50.8224 42.7593 50.6075C43.432 50.3969 43.9263 50.1203 44.2744 49.7447C44.6056 49.3874 44.9094 48.8281 45.0072 47.8504C45.0685 47.2373 44.9619 46.8039 44.7805 46.4773C44.5951 46.1433 44.2698 45.8105 43.7199 45.508C42.5718 44.8764 40.6654 44.4997 37.9998 44.4997C36.0487 44.4997 34.7355 43.5609 33.8124 42.3435C33.1258 41.438 32.5905 40.2788 32.1233 39.2673C32.0236 39.0512 31.9269 38.8419 31.8325 38.6432C31.2462 37.4088 30.677 36.3935 29.8853 35.6683C29.1711 35.014 28.1961 34.5257 26.6274 34.5007Z"
      fill="#005CD6"
    />
  </svg>
);

CastIron.propTypes = {
  style: PropTypes.object,
};

export default {
  aspectRatio: 78 / 76,
  svg: CastIron,
  title,
};
